(function ($) {
  /**
   * Prevents click events from occurring on elements with the class .ld-item-name
   * instead making the accordion toggle up and down
   */
  $(document).ready(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const isLogin = urlParams.get("login");
    const isReview = urlParams.get("feedback");

    // If on course page and ?review passed, show the feedback tab
    if (isReview && $("body").hasClass("single-sfwd-courses")) {
      $("[aria-controls='feedback-tab']").click();
      setTimeout(() => {
        $("[aria-controls='feedback-tab']").click();
      }, 5);
      // Scroll to feedback tab
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(".ld-tabs").offset().top,
        },
        30
      );
    }

    // If on registration page and ?login passed, show the login form.
    if (isLogin) {
      $("h1").text("Course Login");
      $(".ldregister").hide();
      $(".registration-login").hide();
      $(".registration-login-form").show();
      $(".show-password-reset-link").show();
      $(".show-register-form").show();
    }

    // Update page title on log in page when switching between login and register
    $(".registration-login-link").on("click", function (e) {
      $("h1").text("Course Login");
    });
    $(".show-register-form a").on("click", function (e) {
      $("h1").text("Course Registration");
    });

    $(".ld-item-name").on("click", function (e) {
      let parent = $(this).closest(".ld-item-list-item");

      // Only if it has children
      if (parent.hasClass("ld-expandable")) {
        e.preventDefault();

        parent.find(".ld-expand-button").click();
      }
    });

    $(".ld-item-list a").each(function () {
      if ($(this).attr("href").endsWith(window.location.pathname)) {
        $(this).addClass("is-current-page");
        let parent = $(this).closest(".ld-item-list-item");
        if (parent.length > 0 && !$(this).hasClass("ld-item-name")) {
          // Weirdly needs a timeout to run
          setTimeout(() => {
            parent.find(".ld-expand-button").click();
          }, 5);
        }
      }
    });

    // On Profile page, hijack the clicks on the course links and open the course
    $("#ld-profile .ld-item-name").on("click", function (e) {
      e.preventDefault();
      window.location = $(this).attr("href");
    });
    $("#ld-profile .ld-status").on("click", function (e) {
      let parent = $(this).closest(".ld-item-list-item");
      if (parent.length > 0) {
        let link = parent.find(".ld-item-name");
        window.location = link.attr("href");
      }
    });

    // Change the wording of Learndash buttons
    $(".show-register-form a").text("Don't have an account? Create one today");
    $(".ld-login-modal-wrapper a").text("Create An Account");
  });
})(jQuery);
